module.exports = __webpack_public_path__ + "img/mens_inquiry.ef0dfceb.png";